import * as React from 'react';

const IconsContext = React.createContext({});

export { IconsContext };
